import React from 'react';

const ResetDate = ({defaultDate, editDate}) => {
  if (!editDate) { return (null) }

  return (
    <div className={"card-item"}>
      <p>&nbsp;</p>
      <div className={"card-input"}>
        <button className="reset-date" onClick={()=> editDate(new Date(Date.parse(defaultDate)))}>
          <i className={"fa fa-undo"}></i>
        </button>
      </div>
    </div>
  )
};

export default ResetDate
